import { useAuth } from "@/hooks/useAuth";

/**
 * Single source of truth for "is this visitor browsing without a seat?".
 *
 * `isGuest` is only true once auth has resolved, so gated UI never flashes
 * for a signed-in user on a slow refresh.
 */
export const useGuestMode = () => {
  const { user, loading } = useAuth();
  return {
    authReady: !loading,
    isGuest: !loading && !user,
    isMember: !loading && !!user,
    userId: user?.id as string | undefined,
  };
};

export default useGuestMode;
